module.exports = __webpack_public_path__ + "static/favicon.63bdb722.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.png
// module id = 674
// module chunks = 114276838955818